import { NgModule } from '@angular/core';
import { SignInComponent } from './signin/signin.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SignUpComponent } from './signup/signup.component';
import { LoginRoutingModule } from './login.routing.module';
import { SignUpService } from './signup/signup.service';
import { EnvModule } from '../shared/components/enviroment/env.module';
import { CarimboModule } from '../shared/components/carimbo/carimbo.module';
import { ForgotComponent } from './forgot/forgot.component';
import { SharedModule } from '../shared/shared.module';
import { VMessageModule } from '../shared/components/vmessage/vmessage.module';
import { NotificationsService } from '../shared/notifications/notifications.service';
import { BrowserModule } from '@angular/platform-browser';
import { LoginComponent } from './login.component';


@NgModule({
    declarations: [SignInComponent, SignUpComponent, LoginComponent, ForgotComponent],
    exports: [SignInComponent, SignUpComponent, ForgotComponent, LoginComponent],
    imports: [FormsModule,
        ReactiveFormsModule,
        CommonModule,
        VMessageModule,
        RouterModule,
        LoginRoutingModule,
        EnvModule,
        CarimboModule,
        SharedModule
        ],
    providers: [SignUpService,NotificationsService]
})
export class LoginModule { }